module.exports = __webpack_public_path__ + "img/94.f402fb19.jpg";